import { useEffect, useState } from "react";
import { getPreviousYearDues } from "../services/feeDuesService";
import { PreviousYearDueStudent } from "../types";

export const usePreviousYearDues = () => {
  const [students, setStudents] = useState<PreviousYearDueStudent[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const data = await getPreviousYearDues();
        setStudents(data);
      } catch (err) {
        setError("Failed to load students with previous year dues.");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return { students, loading, error };
};
